const getters = {
  getFlexworkers: state => state.flexworkers,
  getFlexworker: state => state.flexworker

}


export default getters